import React from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import ReactTooltip from 'react-tooltip'
import DeleteButton from '../general/DeleteButton.js'
import GeneralTd from '../table-componets/GeneralTd.js'
import EmailTd from '../table-componets/EmailTd.js'
import PhoneNumberTd from '../table-componets/PhoneNumberTd.js'
import ButtonTd from '../table-componets/ButtonTd.js'

class Household extends React.Component {
  state = {
    members: this.props.members
  }

  deleteMember = (member) => {
    if (confirm('Are you sure you want to delete this member?')) {
      var that = this
      var members = _.reject(this.state.members, { id: member.id })

      axios.delete('/members/' + member.id)
      .then(function (response) {
        toastr.error('Member deleted')
        that.setState({
          members: members
        })
      })
      .catch(function (error) {
        toastr.error('Member not deleted')
        console.log(error)
      })
    }
  }

  renderImg(member) {
    return (
      <img
        src={member.avatar_url}
        style={{ height: '32px', width: '32px' }}
        className='img-circle'
        alt={member.first_name}
      />
    )
  }

  renderBody() {
    var that = this
    var members = []

    _.forEach(this.state.members, function(member, index) {
      members.push(
        <tr key={index}>
          <td>
            <a className='styled-link' href={'/members/' + member.id}>
              {that.renderImg(member)}
            </a>
          </td>
          <td>
            <span className='margin-right-five'>
              {member.last_name}
            </span>

            {member.imported_household_id &&
              <span className='margin-right-five'
                    data-tip='Imported Household ID'>
                {'(' + member.imported_household_id + ')'}
                <ReactTooltip />
              </span>
            }

            {member.imported_member_id &&
              <span className='margin-right-five'
                    data-tip='Imported Member ID'>
                {'(' + member.imported_member_id + ')'}
                <ReactTooltip />
              </span>
            }

            {member.primary &&
              <span data-tip='Primary member of household'>
                <span className='badge'>
                  Primary
                </span>
                <ReactTooltip />
              </span>
            }
          </td>
          <GeneralTd fieldValue={member.first_name} />
          <EmailTd fieldValue={member.email}
                   fieldClassName='hidden-xs'/>
          <PhoneNumberTd fieldValue={member.formatted_phone_number}
                         fieldClassName='hidden-xs' />

          {that.props.currentAccount.group_lesson_access &&
            <td className='hidden-xs'>
              {member.group_lesson_classes}
            </td>
          }

          {that.props.currentUser.admin &&
            <td className='hidden-xs'>
              <button onClick={ function(){ that.deleteMember(member) } }
                 className='btn btn-text pull-right'>
                DELETE
              </button>
            </td>
          }

          <ButtonTd fieldName='EDIT'
                    fieldURL={'/members/' + member.id + '/edit'}
                    fieldClassName='hidden-xs'/>
          <ButtonTd fieldName='VIEW'
                    fieldURL={'/members/' + member.id} />
        </tr>
      )
    })

    return (
      <tbody>
        {members}
      </tbody>
    )
  }

  render() {
    var that = this

    return(
      <div>
        <h1>Household</h1>
        <div className='pull-right'>
          {that.props.currentUser.admin &&
            <a href={'/households/' + that.props.household.id + '/edit'}
               className='btn btn-pink btn-raised btn-long margin-right-five'>
              EDIT
            </a>
          }

          {that.props.currentUser.admin &&
            <DeleteButton fieldId={that.props.household.id}
                          fieldURL={'/households/'}
                          fieldToast='Household deleted'
                          confirmMessage='Are you sure you want to delete this household?' />
          }
        </div>
        <br />
        <br />
        <br />
        <div className='shadowDepth1'>
          <table className='table table-clean table-white'>
            <thead>
              <tr>
                <th></th>
                <th>
                  Last Name
                </th>
                <th>
                  First Name
                </th>
                <th className='hidden-xs'>
                  Email
                </th>
                <th className='hidden-xs'>
                  Phone Number
                </th>

                {that.props.currentAccount.group_lesson_access &&
                  <th className='hidden-xs'>
                    Lessons
                  </th>
                }

                {that.props.currentUser.admin &&
                  <th className='hidden-xs'></th>
                }

                <th></th>
                <th></th>
              </tr>
            </thead>
            {this.renderBody()}
          </table>
        </div>
      </div>
    )
  }
}

Household.propTypes = {
  household: PropTypes.object,
  members: PropTypes.array,
  currentUser: PropTypes.object,
  currentAccount: PropTypes.object
}

export default Household
